import axios from 'axios';
import { Toast } from 'vant';

const service = axios.create({
  baseURL:process.env.NODE_ENV === 'development'?process.env.VUE_APP_BASE_API:'/zcbox-backend/index.php',
  //withCredentials: true,
  timeout: 10000, //超时
});

service.interceptors.request.use(
  function (config) {
    if (config.url !== '/user/login?') {
      let userid = localStorage.getItem('userid');
      config.headers.userid = userid;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  function (response) {
    let { data, code, message } = response.data;
    if (code === 200) {
      return response.data;
    } else {
      Toast(message);
      return Promise.reject(code, message);
    }
  },
   function (error) {
    Toast('请求出错');
    return Promise.reject(error);
  }
);
// 将service 导出
export default service;
